import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SetItemPayload {
  name: string;
  value: any;
}

const initialState: any = {
  isLoading: false,
};
export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setItem: (state, action: PayloadAction<SetItemPayload>) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = loadingSlice.actions;

export default loadingSlice.reducer;
